import { normalizeBrokerSlug } from "@/utils/brokerLiveSync"

/** Served from `public/broker-icon-logos/`. */
const BROKER_ICON_LOGOS_PUBLIC_DIR = "/broker-icon-logos"

/** Filenames under `public/broker-icon-logos/`. */
const BROKER_ICON_LOGO_FILES: Record<string, string> = {
  binance: "binance-icon-logo.png",
  ibkr: "interactivebroker-icon-logo.png",
  interactivebrokers: "interactivebroker-icon-logo.png",
  interactivebroker: "interactivebroker-icon-logo.png",
  liquidbrokers: "liquidbrokers-icon-logo.png",
  liquid: "liquidbrokers-icon-logo.png",
  ctrader: "ctrader-icon-logo.png",
  tradingview: "tradingview-icon-logo.png",
  tradingview_paper: "tradingview-icon-logo.png",
  hyperliquid: "hyperliquid-icon-logo.png",
  mt5: "metatrader5-icon-logo.png",
  metatrader5: "metatrader5-icon-logo.png",
  mt4: "metatrader4-icon-logo.png",
  metatrader4: "metatrader4-icon-logo.png",
  ninjatrader: "ninjatrader-icon-logo.png",
  oanda: "oanda-icon-logo.png",
  tradovate: "tradovate-icon-logo.png",
}

/** Dark-mode icons. Falls back to light file when missing. */
const BROKER_ICON_LOGO_DARK_FILES: Record<string, string> = {
  tradingview: "tradingview-icon-logo-dark-mode.png",
  tradingview_paper: "tradingview-icon-logo-dark-mode.png",
  hyperliquid: "hyperliquid-icon-logo-dark-mode.png",
  oanda: "oanda-icon-logo-dark-mode.png",
}

export type ResolveBrokerIconLogoOptions = {
  /** When true, prefer `*-dark-mode.png` variants when available. */
  dark?: boolean
}

export function resolveBrokerIconLogoUrl(
  brokerName: string,
  options?: ResolveBrokerIconLogoOptions
): string | null {
  const slug = normalizeBrokerSlug(brokerName)
  const file = options?.dark
    ? BROKER_ICON_LOGO_DARK_FILES[slug] ?? BROKER_ICON_LOGO_FILES[slug]
    : BROKER_ICON_LOGO_FILES[slug]
  if (!file) return null
  const base = process.env.PUBLIC_URL || ""
  return `${base}${BROKER_ICON_LOGOS_PUBLIC_DIR}/${file}`
}
